module.exports = __webpack_public_path__ + "media/click.726c6bc2.mp3";